import React, { PureComponent } from 'react';
import { store, persistor } from './../../store';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import AppContainer from 'containers/app/AppContainer';

class AppProvider extends PureComponent {
  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <AppContainer />
          </Router>
        </PersistGate>
      </Provider>
    );
  }
}

export default AppProvider;
